import { generateClient } from "aws-amplify/api";

const client = generateClient();

export async function requestListResource(dispatch, payload) {
  try {
    dispatch({ type: "REQUEST_LIST_RESOURCE" });
    const { status } = payload;
    let items = [];
    let nextToken = "start";
    while (nextToken) {
      const params = { limit: 10, status };
      if (nextToken && nextToken !== "start") {
        params.nextToken = nextToken;
      }
      const res = await client.graphql({
        query: taxResourcesByStatusCreatedAt,
        variables: params,
      });

      items = [...items, ...res.data.taxResourcesByStatusCreatedAt.items];
      nextToken = res.data.taxResourcesByStatusCreatedAt.nextToken;
    }
    items = items.map((item) => {
      item.label = item.name;
      item.value = item.id;
      return item;
    });
    dispatch({
      type: "SUCCESS_LIST_RESOURCE",
      payload: { items },
    });
  } catch (error) {
    dispatch({ type: "ERROR_LIST_RESOURCE", error });
  }
}

const taxResourcesByStatusCreatedAt = /* GraphQL */ `
  query TaxResourcesByStatusCreatedAt(
    $status: TaxResourceStatus
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTaxResourceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    taxResourcesByStatusCreatedAt(
      status: $status
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        title
        body
        category {
          id
          name
        }
        rule {
          id
          number
          topic
          description
          publishedDate
          year
          url
          createdAt
          updatedAt
        }
        validFrom
        validUntil
        replacementID
        replacedBy {
          id
          status
          title
          body
        }
        files {
          bucket
          region
          key
          identityId
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
